(() => {
  const players = new Map();

  const stopPlayer = (button) => {
    const audio = players.get(button);
    if (audio) {
      audio.pause();
      audio.currentTime = 0;
    }
    button.setAttribute('aria-pressed', 'false');
    button.setAttribute('aria-label', button.dataset.playLabel || 'Fragment beluisteren');
  };

  const initAudioButton = (button) => {
    if (button.dataset.sprReady === 'true') return;
    button.dataset.sprReady = 'true';
    button.setAttribute('aria-pressed', 'false');

    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const source = button.dataset.audioSrc;
      if (!source) return;

      document.querySelectorAll('.spr-audio-button[aria-pressed="true"]').forEach((other) => {
        if (other !== button) stopPlayer(other);
      });

      let audio = players.get(button);
      if (!audio) {
        audio = new Audio(source);
        players.set(button, audio);
        audio.addEventListener('ended', () => stopPlayer(button));
        audio.addEventListener('error', () => stopPlayer(button));
      }

      if (audio.paused) {
        audio.play().then(() => {
          button.setAttribute('aria-pressed', 'true');
          button.setAttribute('aria-label', button.dataset.pauseLabel || 'Fragment pauzeren');
        }).catch(() => stopPlayer(button));
      } else {
        audio.pause();
        button.setAttribute('aria-pressed', 'false');
        button.setAttribute('aria-label', button.dataset.playLabel || 'Fragment beluisteren');
      }
    });
  };

  const init = (scope = document) => {
    scope.querySelectorAll('.spr-audio-button').forEach(initAudioButton);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
